import { autoinject } from "aurelia-dependency-injection";
import { PipelineExecutionMetricsRequest, PipelineExecutionMetricsResponse } from "../../views/pages/modules/pipeline-executions/pipeline-executions.models";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";

@autoinject()
export class PipelineExecutionsService {
    constructor(private requestClient: RequestClientService) {
    }

    public getPipelineExecutionMetrics(filter: PipelineExecutionMetricsRequest): Promise<PipelineExecutionMetricsResponse> {
        return this.requestClient.post('PipelineExecutionMetrics/GetPipelineExecutionMetrics', {}, filter);
    }
}